export const isSuperAdmin = (role) => {
    if (['super-admin'].includes(role)) {
        return true;
    }
    return false;
};
export const isAdmin = (role) => {
    if (['admin', 'super-admin'].includes(role)) {
        return true;
    }
    return false;
};
export const isDebtor = (role) => {
    if (['debtor', 'alternative-contact'].includes(role)) {
        return true;
    }
    return false;
};
export const isClient = (role) => {
    if (['client'].includes(role)) {
        return true;
    }
    return false;
};
export const isCaseworker = (role) => {
    if (['caseworker', 'admin', 'super-admin'].includes(role)) {
        return true;
    }
    return false;
};
export const hasScope = (me, tenantId, scope) => {
    const tenantRelation = me.tenants.find((t) => t.id === tenantId);
    return !!tenantRelation?.scopes.includes(scope);
};
// The role a user holds on a specific tenant. `user.role` is the global role,
// which is whatever the user was first created as — a user created as admin on
// one tenant and later added as a client on another still has `role: 'admin'`.
// Any tenant-scoped permission decision must use the relation role instead, and
// gets `null` when the user has no relation to the tenant at all.
export const getTenantRole = (me, tenantId) => me.tenants.find((t) => t.id === tenantId)?.role ?? null;
//# sourceMappingURL=index.js.map